const name = 'simpleExample'
export default name
